import { CSSObject } from "@emotion/react";
import { mediaQueryStyles, constants } from "@newsela/angelou";

const {
  colors: { ui },
} = constants;
const { mediaQuery: breakpoint } = mediaQueryStyles;
const greyLight = ui.neutral[100];
const commonSpacingPx = "20px";

export const formCardsContainerCss = (renderTopBorder = false): CSSObject => ({
  borderTop: renderTopBorder ? `2px solid ${greyLight}` : "",
  display: "grid",
  gap: commonSpacingPx,
  paddingTop: commonSpacingPx,
  paddingBottom: "15px",
  gridAutoRows: "1fr",
  gridTemplateColumns: "1fr 1fr 1fr",
  alignItems: "stretch",
  [breakpoint.upTo("sm")]: {
    gridTemplateColumns: "1fr",
  },
});
